import { IconButton, InputLabel } from '@material-ui/core';
import React from 'react';
import { IoIosAddCircleOutline } from 'react-icons/io';
import { COLORS } from 'shared/constants/COLORS';

interface Props {
  onClick?: (arg0: { key: string; value: string }) => void;
  attributes: {
    label: string;
    key: string;
  };
  hasValue?: boolean;
}

const CompCardButton: React.FC<Props> = ({ onClick, attributes, hasValue }) => {
  const { label, key } = attributes;

  return (
    <div
      style={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        position: 'relative',
      }}
    >
      <InputLabel id="eyeColour" style={{ color: '#98a1ac' }}>
        {label}
      </InputLabel>

      {onClick ? (
        <IconButton
          onClick={() => {
            if (!hasValue) return;
            return (
              onClick &&
              onClick({
                key: key,
                value: label,
              })
            );
          }}
          style={{
            padding: 5,
            position: 'absolute',
            right: -5,
            color: COLORS.PRIMARY,
          }}
        >
          <IoIosAddCircleOutline />
        </IconButton>
      ) : (
        <React.Fragment />
      )}
    </div>
  );
};

export default CompCardButton;
